<script lang="ts" setup>
const runtimeConfig = useRuntimeConfig();

useSeoMeta({
  title: 'Solutions - Vismo',
  description: 'Vismo is a geospatial data platform that brings your projects to life',
  ogTitle: 'Solutions - Vismo',
  ogDescription: 'Vismo is a geospatial data platform that brings your projects to life',
  ogImage: joinPath(runtimeConfig.public.siteUrl, 'og.png'),
  ogUrl: joinPath(runtimeConfig.public.siteUrl, '/solutions'),
  twitterTitle: 'Solutions - Vismo',
  twitterDescription: 'Vismo is a geospatial data platform that brings your projects to life',
  twitterCard: 'summary_large_image',
  twitterImage: joinPath(runtimeConfig.public.siteUrl, 'twitter.png'),
});
</script>

<template>
  <div class="solutions-index">
    <section class="solutions-index__content">
      <h1 class="solutions-index__content-title">Solutions 🪄</h1>

      <div class="solutions-index__content-list">
        <article v-for="solution in solutions" :key="solution.to" class="solutions-index__page">
          <h2 class="solutions-index__page-title">
            <NuxtLink :to="solution.to">{{ solution.name }}</NuxtLink>
          </h2>
          <p class="solutions-index__page-description">
            {{ solution.description }}
          </p>
        </article>
      </div>
    </section>

    <MailingList
      title="Stay up to date with our latest blog posts."
      subtitle="Join our mailing list to get the latest updates."
    />
  </div>
</template>

<style scoped lang="scss">
@use '../../assets/styles/_globals.scss' as g;

.solutions-index {
  display: flex;
  flex-direction: column;
  gap: 5rem;
  overflow: hidden;

  &__content {
    display: flex;
    flex-direction: column;
    gap: 3rem;

    margin: 0 11rem;

    @media (max-width: g.$desktop-breakpoint) {
      margin: 0 6rem;
    }

    @media (max-width: g.$mobile-breakpoint) {
      margin: 2rem;
    }
  }

  &__content-title {
    font-size: 2.3rem;
    font-weight: 800;
    text-align: center;
  }

  &__content-list {
    display: grid;
    gap: 3rem;
    grid-template-columns: repeat(auto-fill, minmax(23rem, 1fr));

    @media (max-width: g.$mobile-breakpoint) {
      grid-template-columns: 1fr;
    }
  }

  &__page {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  &__page-title {
    font-size: 1.5rem;
    font-weight: 800;

    @media (max-width: g.$mobile-breakpoint) {
      font-size: 1.2rem;
    }
  }

  &__page-description {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.4;
  }
}
</style>
